import { ApolloType } from "@/enum/apollo.enum";
import { useGetListQuery } from "@/pages/Private/redux/list/list.api";

import { List } from "../../schema/list";

/** A tracker list's Find person switch, kept in its source apollo config (PREC-4399). */
export const findPersonOnSignalOf = (list: List | undefined): boolean =>
	list?.apollos?.find((apollo) => apollo.type === ApolloType.SOURCE)?.config?.findPersonOnSignal ===
	true;

/** The switch of the list a row belongs to; on a list page the list is already in the cache. */
export const useTrackerFindPersonEnabled = (listId: number | undefined, skip = false): boolean => {
	const { data } = useGetListQuery(listId ?? 0, { skip: skip || !listId });

	return findPersonOnSignalOf(data);
};
